<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template #thead-top="data">
        <b-tr v-if="tableType === 'lastYear'">
          <b-th colspan="1" style="text-align: center"></b-th>
          <b-th colspan="3" style="text-align: center">疏花</b-th>
          <b-th colspan="3" style="text-align: center">疏果</b-th>
          <b-th colspan="3" style="text-align: center">套袋</b-th>
          <b-th colspan="2" style="text-align: center">损耗占比</b-th>
          <b-th colspan="3" style="text-align: center"></b-th>
        </b-tr>
        <b-tr v-else>
          <b-th colspan="1" style="text-align: center"></b-th>
          <b-th colspan="3" style="text-align: center">套袋</b-th>
          <b-th colspan="1" style="text-align: center"></b-th>
          <b-th colspan="1" style="text-align: center"></b-th>
          <b-th colspan="3" style="text-align: center"></b-th>
          <b-th colspan="1" style="text-align: center"></b-th>
        </b-tr>
      </template>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:table-colgroup="scope">
        <col v-for="field in scope.fields" :key="field.key" :style="{ width: field.width }">
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "ApmsRegAnnualYieldForecastDetail",
  data() {
    return {
      tableType: 'lastYear',
      lastYearFields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'thinFlowerBunchCount', label: '串数', width: '100px'},
        {key: 'thinFlowerBunchPerMu', label: '串/亩', width: '100px'},
        {key: 'thinFlowerBunchPerTree', label: '串/棵', width: '100px'},
        {key: 'thinFruitBunchCount', label: '串数', width: '100px'},
        {key: 'thinFruitBunchPerMu', label: '串/亩', width: '100px'},
        {key: 'thinFruitBunchPerTree', label: '串/棵', width: '100px'},
        {key: 'baggingBunchCount', label: '串数', width: '100px'},
        {key: 'baggingBunchPerMu', label: '串/亩', width: '100px'},
        {key: 'baggingBunchPerTree', label: '串/棵', width: '100px'},
        {key: 'lossBunchCount', label: '串数', width: '100px'},
        {key: 'lossRate', label: '损耗(%)', width: '100px'},
        {key: 'pickYieldPerMu', label: '采摘亩产(斤)', width: '120px'},
        {key: 'bunchWeight', label: '串均重量(斤)', width: '120px'},
        {key: 'totalYield', label: '产量(斤)', width: '120px'},
      ],
      currentYearFields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'baggingBunchCount', label: '串数', width: '120px'},
        {key: 'baggingBunchPerMu', label: '串/亩', width: '120px'},
        {key: 'baggingBunchPerTree', label: '串/棵', width: '120px'},
        {key: 'forecastBunchWeight', label: '预测串均重量(斤)', width: '140px'},
        {key: 'forecastYield', label: '预测产量(斤)', width: '140px'},
        {key: 'lossRate', label: '预估损耗(%)', width: '130px'},
        {key: 'lossWeight', label: '损耗数量(斤)', width: '140px'},
        {key: 'forecastSellableWeight', label: '预测可售重量(斤)', width: '150px'},
      ],
      items: [],
    }
  },
  computed: {
    fields1() {
      return this.tableType === 'lastYear' ? this.lastYearFields : this.currentYearFields
    }
  },
  created() {
    this.tableType = this.$route.query.type || 'lastYear'
    const data = this.$route.query.data
    if (data) {
      const parsed = JSON.parse(data)
      this.items = [{ ...parsed, index: 1 }]
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
  }
}
</script>

<style scoped>
</style>
